import React, { FC, useContext } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { RegistrationLayoutProfile } from '../RegistrationLayoutProfile/RegistrationLayoutProfile'
import { LocaleContext } from '../../../../components/LocaleContext/LocaleContext'
import { getQueryParam } from '../../../../utils/getQueryParam'
import { Languages } from '../../../../interfaces/common'
import { BackArrowButton } from '../../../../components/BackArrowButton/BackArrowButton'
import style from './RegistrationLayoutHeader.module.css'
import { RegistrationLogo } from '../../../../components/RegistrationLogo/RegistrationLogo'
import { LocalizationButton } from '../../../../components/LocalizedButton/LocalizedButton'

type RegistrationLayoutHeaderProps = {
  withIsLoginRedirect?: boolean
  hasBackArrow?: boolean
  withProfile?: boolean
  withLocalizationButton?: boolean
}

export const RegistrationLayoutHeader: FC<RegistrationLayoutHeaderProps> = ({
  withIsLoginRedirect = false,
  hasBackArrow = false,
  withProfile,
  withLocalizationButton = false,
}) => {
  const { query } = useRouter()
  const widget = getQueryParam(query, 'widget')
  const { locale } = useContext(LocaleContext)

  const isShowCustomLanguageButton = withLocalizationButton && locale === Languages.UZ
  const shouldShowLeftContent = !widget
  const shouldShowRightContent = isShowCustomLanguageButton || withProfile
  const shouldRenderContainer = shouldShowLeftContent || shouldShowRightContent

  const className = classNames(style.layout, {
    [style.widgetLayout]: widget,
  })

  return shouldRenderContainer ? (
    <div className={className}>
      {shouldShowLeftContent && (
        <span>
          {hasBackArrow && <BackArrowButton className={style.backArrow} />}
          <RegistrationLogo className={style.logo} />
        </span>
      )}

      {shouldShowRightContent && (
        <span className={style.buttons}>
          {isShowCustomLanguageButton && <LocalizationButton />}
          {withProfile && <RegistrationLayoutProfile withIsLoginRedirect={withIsLoginRedirect} />}
        </span>
      )}
    </div>
  ) : null
}

RegistrationLayoutHeader.displayName = 'RegistrationLayoutHeader'
